// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var isObject = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
var isStringArray = function (value) {
    return Array.isArray(value) && value.every(function (item) { return typeof item === "string"; });
};
var isOptionalString = function (value) {
    return value === undefined || value === null || typeof value === "string";
};
var isResultsAccess = function (value) {
    return value === "public" || value === "authenticated";
};
var isResultsVisibilityScope = function (value) {
    return value === "full_event" || value === "area_based";
};
var isResultsRouteScope = function (value) {
    return value === "event" || value === "election";
};
var isPublicationIndexEntry = function (value) {
    return isObject(value) &&
        typeof value.publication_id === "string" &&
        isResultsRouteScope(value.route_scope) &&
        isResultsAccess(value.access) &&
        isOptionalString(value.route) &&
        isOptionalString(value.route_election_id) &&
        (value.election_ids === undefined || isStringArray(value.election_ids)) &&
        (value.visibility_scope === undefined || isResultsVisibilityScope(value.visibility_scope)) &&
        isOptionalString(value.manifest_public_path) &&
        isOptionalString(value.manifest_url);
};
export var parseResultsPublicationIndex = function (value) {
    if (isPublicationIndexEntry(value)) {
        return { schema_version: 1, publications: [value] };
    }
    if (!isObject(value) ||
        typeof value.schema_version !== "number" ||
        (value.publications !== undefined &&
            (!Array.isArray(value.publications) ||
                !value.publications.every(isPublicationIndexEntry)))) {
        throw new Error("Invalid results publication index");
    }
    return value;
};
var isManifestContest = function (value) {
    return isObject(value) &&
        typeof value.election_id === "string" &&
        typeof value.contest_id === "string" &&
        (value.publication_state === "published" || value.publication_state === "not_published");
};
var isManifestArtifact = function (value) {
    return isObject(value) &&
        isOptionalString(value.public_path) &&
        isOptionalString(value.url) &&
        isOptionalString(value.document_id);
};
var isManifestArtifactMap = function (value) {
    return isObject(value) && Object.values(value).every(isManifestArtifact);
};
var isManifestArtifacts = function (value) {
    return isObject(value) &&
        (value.full_sqlite === undefined ||
            value.full_sqlite === null ||
            isManifestArtifact(value.full_sqlite)) &&
        (value.areas === undefined || value.areas === null || isManifestArtifactMap(value.areas));
};
export var parseResultsManifest = function (value) {
    if (!isObject(value) ||
        typeof value.schema_version !== "number" ||
        typeof value.tenant_id !== "string" ||
        typeof value.election_event_id !== "string" ||
        !isStringArray(value.election_ids) ||
        !isResultsRouteScope(value.route_scope) ||
        typeof value.publication_id !== "string" ||
        typeof value.results_event_id !== "string" ||
        typeof value.version !== "number" ||
        !isResultsAccess(value.access) ||
        !isResultsVisibilityScope(value.visibility_scope) ||
        !Array.isArray(value.contests) ||
        !value.contests.every(isManifestContest) ||
        !isManifestArtifacts(value.artifacts)) {
        throw new Error("Invalid results publication manifest");
    }
    return value;
};
